import { render, staticRenderFns } from "./TotalSelected.vue?vue&type=template&id=2a66164a&scoped=true&"
import script from "./TotalSelected.vue?vue&type=script&lang=js&"
export * from "./TotalSelected.vue?vue&type=script&lang=js&"
import style0 from "./TotalSelected.vue?vue&type=style&index=0&id=2a66164a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a66164a",
  null
  
)

export default component.exports